import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { apiRequest } from "../../helpers/api";
import { SkeletonPage } from "../../components/skeleton/Skeleton";

// Former /admin/users/:userId pages open the same user in the Users page's Quick View.
export const LegacyUserRedirect = () => {
  const { userId } = useParams();
  return <Navigate to={`/admin/users?user=${encodeURIComponent(userId)}`} replace />;
};

// Former /admin/businesses/:businessId pages open the owner's Quick View on the Business profile tab.
export const LegacyBusinessRedirect = () => {
  const { businessId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    apiRequest(`/api/admin/businesses/${encodeURIComponent(businessId)}`)
      .then(({ owner }) => {
        if (!active) return;
        if (owner?.role === "user") navigate(`/admin/users?user=${owner.id}&tab=business`, { replace: true });
        else setError("This business profile belongs to an administrator account, not a customer.");
      })
      .catch((requestError) => { if (active) setError(requestError.message || "Unable to open this business profile."); });
    return () => { active = false; };
  }, [businessId, navigate]);

  if (!error) return <SkeletonPage label="Opening business profile" />;
  return (
    <section className="workspace-dashboard">
      <div className="workspace-empty admin-users-empty" role="alert">
        <strong>{error}</strong>
        <span>Business profiles are now part of each user's Quick View. <Link className="admin-inline-link" to="/admin/users">Go to Users</Link></span>
      </div>
    </section>
  );
};
